/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sla_RemainingInputs */

const vi_sla_remaining = /** @type {(inputs: Sla_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`còn lại`)
};

/**

* @param {Sla_RemainingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sla_remaining = /** @type {((inputs?: Sla_RemainingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sla_RemainingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sla_remaining(inputs)
});